import React, { Component, Fragment } from "react";
import axios from "axios";
import { AUTH_FILE_BUFFER_URL, INVALID_MESSAGE, LOADER_RED } from "../../constant";
// import PDFViewer from "./PDFViewer";
import PDFViewerV2 from "./PDFViewerV2";
export default class ViewDocument extends Component {
  constructor(props) {
    super(props);
    const params = new URLSearchParams(window.location.search);
    this.state = {
      getDoc: decodeURIComponent(params.get('doc')) || null,
      getCol: params.get("col") || null,
      getModule: params.get("module") || null,
      getToken: params.get("token") || null,
      showLoader: false,
      rxFilePath: null,
      fileContentType: 'application/pdf',
      message: { type: '', text: '' }
    };
    this.isEffectRun = false;
  }

  componentDidMount() {
    if (!this.isEffectRun) {
      this.getDocumentBuffer();
      this.isEffectRun = true; // Mark as executed
    }
  }

  async getDocumentBuffer() {
    const { getDoc, getCol, getModule, getToken } = this.state;
    try {
      if (getDoc && getCol && getModule && getToken) {
        const headers = { "Authorization": getToken };
        const payloadObj = { filepath: getDoc, "col": getCol, "module": getModule };
        let bufferApiRes = await axios.post(AUTH_FILE_BUFFER_URL, payloadObj, { responseType: "arraybuffer", headers });
        if (bufferApiRes.status === 200 && bufferApiRes?.data) {
          const contentType = bufferApiRes.headers['content-type'];
          // console.log('-----get-content-type:', contentType);
          const blob = new Blob([bufferApiRes.data], { type: contentType });
          const url = URL.createObjectURL(blob);
          this.setState({ showLoader: false, rxFilePath: url, fileContentType: contentType });
        }
        else {
          this.setState({ showLoader: false, message: { type: 'error', text: INVALID_MESSAGE } });
        }
      } else {
        console.log("get-document-buffer-err: getDoc, getCol, getModule, getToken not found");
        this.setState({ showLoader: false, message: { type: 'error', text: INVALID_MESSAGE } });
      }
    } catch (err) {
      console.log("get-document-buffer-err:", err);

      let errorMessage = INVALID_MESSAGE;
      if (err.response?.data) {
          try {
              errorMessage = JSON.parse(new TextDecoder().decode(new Uint8Array(err.response.data))).message || errorMessage;
          } catch { }
      }

      this.setState({ showLoader: false, message: { type: "error", text: errorMessage } });
    }
  }

  render() {
    const { showLoader, rxFilePath, fileContentType, message } = this.state;

    return (
      <Fragment>
        {showLoader ? <div className="d-flex justify-content-center align-items-center">
          <p className="mx-auto d-block mt-4 mb-2">{LOADER_RED}</p>
        </div> : null}

        {rxFilePath ? (
          <div className="full-screen-frame">
            {fileContentType.includes('pdf') ? (
              <PDFViewerV2 pdfUrl={rxFilePath} />
              // <PDFViewer pdfUrl={rxFilePath} />
              // <iframe src={rxFilePath} frameBorder="0" scrolling="no" className="iframe-style" alt="PDF Document">{LOADER_RED}</iframe>
            ) : (
              <img src={rxFilePath} alt="Image Document" className="iframe-style" />
            )}
          </div>
        ) : null}

        {message.text && (
          <div className="d-flex justify-content-center align-items-center vh-100">
            <div role="alert" className={`alert ${message.type === 'error' ? 'alert-danger' : message.type === 'success' ? 'alert-success' : 'alert-info'}`}>
              {message.text}
            </div>
          </div>
        )}
      </Fragment>
    );
  }
}